'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import Banana from '@repo/ui/Banana';
import { useEffect } from 'react';
export default function GlobalError(t0) {
  const $ = _c(5);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      if (error) {
        datadogRum.addError(error, {
          message: "Fatal error triggered root client error boundary"
        });
      } else {
        datadogRum.addError(new Error("Unknown fatal error triggered root client error boundary"));
      }
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== reset) {
    t3 = <html lang="en"><body><Banana reset={reset} /></body></html>;
    $[3] = reset;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}